import React from 'react'
import { Col, Alert } from 'react-bootstrap'

export const TokenSuccessDisplay = ({ token_number }: { token_number: string }) => {
  return (
    <Col xs={12} className="p-0 mt-3">
      <Alert variant="success" className="shadow-sm rounded">
        <h5 className="mb-3">🎉 You're all set!</h5>
        <p>
          <strong>Your Visitor ID:</strong> <span className="text-primary">{token_number}</span>
        </p>
        <p>📩 We've sent this information to your registered contact via SMS.</p>
        <p>⏳ Please wait — your counter number will be displayed shortly on the terminal window.</p>
      </Alert>
    </Col>
  )
}

export const TokenErrorDisplay = ({ message }: { message: string }) => {
  return (
    <Col xs={12} className="p-0 mt-3">
      <Alert variant="danger" className="shadow-sm rounded">
        <h5 className="mb-3">⚠️ Something went wrong</h5>
        <p>{message}</p>
        <p className="text-muted">Please try again or contact support if the issue persists.</p>
      </Alert>
    </Col>
  )
}
